const preloadedState = {
	orderRef: undefined,
	autoStartToken: undefined,
	initiatePolling: false,
	showCompliance: false,
	extraInfoPrompt: false,
	accountLink: false,
	loading: false,
	sessionCriteria: false,
	qrMode: false,
	isSwishInstalledOnMobile: false
};

export default preloadedState;
